'use client'

import {
  CartSummaryDisabledButton,
  CartSummaryErrorTooltip,
  type PaymentActionPortProps,
  useCartStore,
  useDisplayCart
} from 'modules/cart'
import Button from 'shared/ui/Button'
import { removeEmptySpacesFromCurrency } from 'shared/utils/currency'
import { addTestId } from 'shared/utils/tests'

import { useCheckoutPaymentValidation } from '../hooks/useCheckoutPaymentValidation'
import { usePlaceSaleOrder } from '../hooks/usePlaceSaleOrder'

const PlaceSaleOrderButton = ({
  cartValidationErrors,
  paymentValue,
  testTag
}: PaymentActionPortProps) => {
  const cart = useDisplayCart()
  const isCartLoading = useCartStore(state => state.isLoading)
  const errors = useCheckoutPaymentValidation(cartValidationErrors)
  const { handlePlaceSaleOrder, isPlacingSaleOrder } = usePlaceSaleOrder()

  const isCartEditMode = cart?.editMode ?? false

  if (errors.length > 0) {
    return isCartEditMode ? (
      <CartSummaryErrorTooltip errors={errors}>
        <></>
      </CartSummaryErrorTooltip>
    ) : (
      <CartSummaryDisabledButton
        errors={errors}
        id='cart_summary_proceed_payment_button'
        loading={isCartLoading || isPlacingSaleOrder}
        testTag={testTag}
      >
        Płacę i zamawiam
      </CartSummaryDisabledButton>
    )
  }

  if (isCartEditMode) return <></>

  return (
    <Button
      id='cart_summary_payment_confirmation'
      variant='primary'
      size='large'
      fullWidth
      loading={isPlacingSaleOrder}
      disabled={isPlacingSaleOrder}
      onClick={handlePlaceSaleOrder}
      {...addTestId(testTag)}
    >
      {`Płacę i zamawiam ${removeEmptySpacesFromCurrency(paymentValue)}`}
    </Button>
  )
}

export default PlaceSaleOrderButton
